var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 0.599976C7.04661 0.599976 0.599609 7.04698 0.599609 15C0.599609 22.953 7.04661 29.4 14.9996 29.4C22.9526 29.4 29.3996 22.953 29.3996 15C29.3996 7.04698 22.9526 0.599976 14.9996 0.599976ZM11.4746 20.9685H8.55861V11.5845H11.4746V20.9685ZM9.99861 10.4325C9.07761 10.4325 8.48211 9.77997 8.48211 8.97297C8.48211 8.14948 9.09561 7.51648 10.0361 7.51648C10.9766 7.51648 11.5526 8.14948 11.5706 8.97297C11.5706 9.77997 10.9766 10.4325 9.99861 10.4325ZM22.1246 20.9685H19.2086V15.768C19.2086 14.5575 18.7856 13.7355 17.7311 13.7355C16.9256 13.7355 16.4471 14.292 16.2356 14.8275C16.1576 15.018 16.1381 15.288 16.1381 15.5565V20.967H13.2206V14.577C13.2206 13.4055 13.1831 12.426 13.1441 11.583H15.6776L15.8111 12.8865H15.8696C16.2536 12.2745 17.1941 11.3715 18.7676 11.3715C20.6861 11.3715 22.1246 12.657 22.1246 15.42V20.9685Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLinkedin);
export default __webpack_public_path__ + "static/media/color_linkedin.091a9aca4f367f585de5bf7cb43db18a.svg";
export { ForwardRef as ReactComponent };